import { render, staticRenderFns } from "./EditUserModal.vue?vue&type=template&id=5b8972b6&scoped=true"
import script from "./EditUserModal.vue?vue&type=script&lang=js"
export * from "./EditUserModal.vue?vue&type=script&lang=js"
import style0 from "./EditUserModal.vue?vue&type=style&index=0&id=5b8972b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8972b6",
  null
  
)

export default component.exports